import React, { useState } from 'react';
import { parse } from 'date-fns';
import { MobileDatePicker as BaseDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import enGB from 'date-fns/locale/en-GB';

const DatePicker = (props) => {
  const {
    date,
    dateFormat = 'dd/MM/yyyy',
    disabled = false,
    variant = 'dialog',
    showInput = false,
    applyDate,
    acceptDateFunction,
    open,
    inputId,
    inputName,
    inputRef,
    className,
    registerProps,
    actions = [],
  } = props;
  const [isOpen, setIsOpen] = useState(open);
  const [selectedDate, setSelectedDate] = useState(date ? parse(date, dateFormat, new Date()) : null);

  const handleClose = () => setIsOpen(false);
  const handleDateChange = (value) => {
    setSelectedDate(value);
    if (applyDate) {
      if (typeof applyDate === 'function') {
        applyDate(value);
      } else if (typeof window[applyDate] === 'function') {
        window[applyDate](value);
      }
    }
    if (open) handleClose();
  };

  const handleAccept = (value) => {
    if (acceptDateFunction) {
      if (typeof acceptDateFunction === 'function') {
        acceptDateFunction(value);
      } else if (typeof window[acceptDateFunction] === 'function') {
        window[acceptDateFunction](value);
      } else {
        handleDateChange(value);
      }
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
      <BaseDatePicker
        variant={variant}
        value={selectedDate}
        onClose={handleClose}
        onChange={handleDateChange}
        onAccept={handleAccept}
        autoOk
        closeOnSelect={actions.length === 0}
        disabled={disabled}
        format="dd/MM/yyyy"
        {...(open && { open: isOpen })}
        {...(variant === 'dialog' && { okLabel: '' })}
        {...(!showInput && { TextFieldComponent: () => null })}
        slotProps={{
          textField: {
            InputProps: {
              ref: inputRef,
              fullWidth: true,
              className,
              name: inputName,
              id: inputId,
              ...registerProps,
            },
          },
          actionBar: {
            actions,
          },
        }}
        PopoverProps={{ disableRestoreFocus: true }}
        {...registerProps}
      />
    </LocalizationProvider>
  );
};
export default DatePicker;
